// extracted by mini-css-extract-plugin
module.exports = {"buildControl":"BuildControl_buildControl__2wAax","label":"BuildControl_label__FbyCO","less":"BuildControl_less__3eDis","more":"BuildControl_more__2xuW5"};